export function convertCodeForSearch(code: string) {
  switch (code) {
    case 'hcc':
      return 'cms-hcc';
    case 'hhshcc':
      return 'hhs-hcc';
    default:
      return code;
  }
}
